<template>
  <article class="layout-section -no-top">
    <div class="rte" v-html="wp.content" />
  </article>
</template>

<script>
export default {
  name: 'ProjectsSingleContent',
  inject: ['wp']
}
</script>
